import React, { memo } from 'react';
import PropTypes from 'prop-types';

const ModalHeader = ({
  leftArea, centerArea, rightArea, children
}) => (
  <div className="generic-modal-header">
    {
      leftArea && (
        <div className="generic-modal-header__left-area">
          {leftArea}
        </div>
      )
    }
    {
      centerArea && (
        <div className="generic-modal-header__center-area">
          {centerArea}
        </div>
      )
    }
    {
      rightArea && (
        <div className="generic-modal-header__right-area">
          {rightArea}
        </div>
      )
    }
    { !leftArea && !centerArea && !rightArea && children }
  </div>
);

ModalHeader.propTypes = {
  leftArea: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  centerArea: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  rightArea: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

ModalHeader.defaultProps = {
  leftArea: null,
  centerArea: null,
  rightArea: null,
  children: null
};

export default memo(ModalHeader);
